export default {
    async buscaLigacoes ({getters, commit}, filtro)
    {
        let {data} = await getters.getApi.get("voicecalls", { params: filtro })
        commit('SET_CHAMADAS', data)
        return true
    },

    async protaxi_ligar ({getters, commit}, {origem, destino})
    {
        let {data} = await getters.getApi.post("voicecalls/dial", {
            src_phone: `0${origem}`,
            src_name: `Origem 0${origem}`,
            dst_phone: `0${destino}`,
            dst_name: `Destino 0${destino}`,
            detail: 'Protáxi',
            requested: 'passageiro',
            webhook_url: '',
            webhook_method: 'POST'
        })
        return data.status
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/protaxi/actions.js